const QUAN_LY_TAI_KHOAN = "/system_management"
const ROUTER = {
  SVG_VIEWER: "/svg-viewer",
  TEST: "/test",
  ROOT: "/home-page",
  HOME_PAGE_CUSTOMER: "/",
  HOME_PAGE: "/home-page",
  SEARCH_JOURNEY_ORDER: "/tra-cuu-hanh-trinh-don",
  DANG_NHAP: "/login",
  DANG_KY: "/register",
  ACCOUNT: "/account",
  //ANONYMOUS
  PROCEDURE: "/procedure",
  // ADMIN
  QUAN_LY_TAI_KHOAN: "/system_management",
  QUAN_LY_KE_TOAN: `${QUAN_LY_TAI_KHOAN}/management_of_accounting_system`,
  LIEN_HE: `${QUAN_LY_TAI_KHOAN}/contact`,
  CO_HOI: `${QUAN_LY_TAI_KHOAN}/opportunity`,
  QUAN_LY_NHAN_SU: `${QUAN_LY_TAI_KHOAN}/hrm`,
  // SETTING_PERMISSIONS: `${QUAN_LY_TAI_KHOAN}/setting_permissions`,
  SALARY_CONFIG: `${QUAN_LY_TAI_KHOAN}/salary-config`,

  // HR - Nhân sự
  HR: "/hr",
  //--Hồ sơ nhân sự
  HR_FILES: "/hr/files",
  SALARY: "/hr/salary",
  WEEKLY_BONUS: "/hr/weekly-bonus",
  // SALARY_CONFIG: "/hr/salary-config",
  //--Hợp đồng
  HR_CONTRACT: "/hr/contract",
  //--Bảo hiểm
  HR_INSURANCE: "/hr/insurance",
  //---Chấm công
  HR_TIMEKEEPING: "/hr/timekeeping",
  //--Bảng lương
  HR_PAYROLL: "/hr/payroll",
  //--Thưởng phạt
  HR_REWARDS: "/hr/rewards",
  //--Đánh giá
  HR_EVALUATION: "/hr/evaluation",
  HR_EVALUATION_SYNTHETIC: "/hr/evaluation/synthetic",
  //--Tuyển dụng
  HR_HIRING: "/hr/hiring",
  // yêu cầu tuyển dụng
  HR_JOB_REQUESTS: "/hr/job-requests",
  // hồ sơ ứng viên
  HR_CANDIDATE_PROFILES: "/hr/candidate-profiles",
  // lịch phỏng vấn
  HR_INTERVIEW_SCHEDULES: "/hr/interview-schedules",
  // Work - Công việc
  WORK_TASK: "hr/work/task",
  // Báo cáo
  WORK_TASK_JOB: "hr/work/task/Job",
  WORK_TASK_STAFF: "hr/work/task/staff",
  WORK_TASK_DEPARTMENT: "hr/work/task/Department",
  // DOCUMENT - Tài liệu
  DOCUMENT: "hr/document",
  // Applications - Đơn từ
  APPLICATION: "hr/application",
  //--Đơn xin nghỉ
  APPLICATION_LEAVE: "hr/application/leave",
  //--Đơn xin vắng mặt
  APPLICATION_ABSENCE: "hr/application/absence",
  //--Đơn xin làm thêm
  APPLICATION_OVERTIME: "hr/application/overtime",
  //--Đơn thuyên chuyển
  APPLICATION_TRANSFER: "hr/application/transfer",
  //--Đơn thôi việc
  APPLICATION_RESIGNATION: "hr/application/resignation",

  // Target - Mục tiêu
  TARGET: "hr/target",

  // Dashboard
  DASHBOARD: "/dashboard",

  // Customer Care - Chăm sóc khách hàng
  CUSTOMER_CARE: "/customer-care",

  // Hợp đồng bảo hiểm
  INSURANCE_DECLARATION: "hr/insurance-declaration",
  LABOR_CONTRACT: "hr/labor-contract",

  //--Báo cáo
  HR_REPORT: "/hr/report",

  // Bussiness - Kinh Doanh
  //--Liên hệT
  BUSSINESS_CONTACT: "/bussiness/contact",
  //--Cơ hội
  BUSSINESS_OPPORTUNITY: "/bussiness/opportunity",
  //--Khách hàng
  BUSSINESS_CUSTOMER: "/bussiness/customer",
  //--Tồn kho
  BUSSINESS_INVENTORY: "/bussiness/inventory",
  //--Nhà cung cấp
  BUSSINESS_SUPPLIER: "/bussiness/supplier",
  //--Hợp đồng
  BUSSINESS_CONTRACT: "/bussiness/contract",
  //-Đơn hàng
  BUSSINESS_ORDER: "/bussiness/order",
  //- Báo cáo
  // REPORT: "/report",
  //--Dự án
  BUSSINESS_PROJECT: "/bussiness/project",
  //--Chỉ tiêu
  BUSSINESS_TARGET: "/bussiness/target",

  // Finance - Phieu thu chi
  FINANCE_INTERNAL: "/finance/internal",
  FINANCE_EXTERNAL: "/finance/external",
  FINANCE_REPORT: "/finance/report",

  // Account - Kế toán
  //--Kế toán nội bộ
  ACCOUNT_INTERNAL: "/account-internal",
  ACCOUNT_INTERNAL_SETTING: "/account-internal/setting",
  ACCOUNT_INTERNAL_SETTING1: "/account-internal/setting1",
  ACCOUNT_INTERNAL_FUND: "/account-internal/fund",
  ACCOUNT_INTERNAL_BANK: "/account-internal/bank",
  ACCOUNT_INTERNAL_INVOICE: "/account-internal/invoice",
  // Kho
  ACCOUNT_SIM_WAREHOUSE: "/account/warehouse/sim",
  ACCOUNT_INTERNAL_WAREHOUSE: "/account-internal/warehouse",
  ACCOUNT_WAREHOUSE_OUT: "/account/warehouse/out",
  ACCOUNT_WAREHOUSE_IN: "/account/warehouse/in",
  ACCOUNT_WAREHOUSE_IN_DATA: "/account/warehouse/in/data",
  ACCOUNT_WAREHOUSE_ADJUSTMENT: "/account/warehouse/adjustment",
  ACCOUNT_WAREHOUSE_TRANSFER: "/account/warehouse/transfer",
  ACCOUNT_WAREHOUSE_RETURNED_GOODS: "/account/warehouse/returned-goods",
  ACCOUNT_WAREHOUSE_LIST: "/account/warehouse/list",
  ACCOUNT_WAREHOUSE_GOODS: "/account/warehouse/goods",
  ACCOUNT_WAREHOUSE_SERVICES: "/account/warehouse/services",
  //data request
  ACCOUNT_DATA_REQUEST: "/account/warehouse/data-request",

  // Đề xuất
  ACCOUNT_LIST_REQUEST: "/account/request",

  //-- Tài sản
  ACCOUNT_INTERNAL_ASSET: "/account-internal/asset",
  ACCOUNT_INTERNAL_ASSET_FIX: "/account-internal/asset/fix",
  ACCOUNT_INTERNAL_ASSET_TOOLEQUIT: "/account-internal/asset/toolquit",
  //-- Tiền lương
  ACCOUNT_INTERNAL_SALARY: "/account-internal/salary",
  //-- Hợp đồng
  ACCOUNT_INTERNAL_CONTRACT: "/account-internal/contract",
  //--Bút toán
  ACCOUNT_INTERNAL_JOURNAL_ENTRY: "/account-internal/journal-entry",
  //--Báo cáo
  ACCOUNT_INTERNAL_REPORT: "/account-internal/report",
  //-- Cài đặt
  ACCOUNT_INTERNAL_SETTING_ACCOUNT: "/account-internal/setting/account",
  ACCOUNT_INTERNAL_SETTING_ACCOUNTANT: "/account-internal/setting/accountant",
  // quỹ cấp 2
  //+ phiếu thu,phiếu chi
  // Finance - Phieu thu chi
  ACCOUNT_FINANCE_INTERNAL: "/account-internal/internal",
  ACCOUNT_FINANCE_EXTERNAL: "/account-internal/external",
  //  Ngân Hàng (Phiếu báo nợ,Phiếu báo có,Phiếu chuyển tiền)
  ACCOUNT_FINANCE_DEBT: "/account-internal/debt",
  ACCOUNT_FINANCE_CREDIT: "/account-internal/Credit",
  ACCOUNT_FINANCE_CARTIFICATE: "/account-internal/cartificate",
  // kế toán nội bộ/Hóa đơn
  ACCOUNT_FINANCE_SALES_INVOICE: "/account/finance/sales-invoice",
  ACCOUNT_FINANCE_PURCHASE_INVOICE: "/account/finance/purchase-invoice",
  ACCOUNT_FINANCE_RETURNED_GOODS: "/account/finance/returned-goods",

  //--Kế toán thuế
  ACCOUNT_TAX: "/account-tax",
  ACCOUNT_TAX_SETTING: "/account-tax/setting",
  ACCOUNT_TAX_FUND: "/account-tax/fund",
  ACCOUNT_TAX_BANK: "/account-tax/bank",
  ACCOUNT_TAX_INVOICE: "/account-tax/invoice",
  ACCOUNT_TAX_WAREHOUSE: "/account-tax/warehouse",
  //--Kế toán thuế ->Tài sản
  ACCOUNT_TAX_ASSET: "/account-tax/asset",
  ACCOUNT_TAX_ASSET_FIX: "/account-tax/asset/fix",
  ACCOUNT_TAX_ASSET_TOOLEQUIT: "/account-tax/asset/toolquit",
  ACCOUNT_TAX_SALARY: "/account-tax/salary",
  ACCOUNT_TAX_CONTRACT: "/account-tax/contract",
  ACCOUNT_TAX_JOURNAL_ENTRY: "/account-tax/journal-entry",
  ACCOUNT_TAX_REPORT: "/account-tax/report",

  // ASSET - Tài sản
  ASSETS: "/assets",
  ASSET_ASSIGN: "/asset/assign",
  ASSET_REQUEST_FORM: "/asset/request-form",
  ASSET_STATISTICS: "/asset/statistics",
  ASSET_REPORT: "/asset/report",
  ASSET_CHART: "/asset/chart",

  // Menu Routes
  HOME: "/home",

  HOME_WAIT_APPROVAL: "/home/wait-approval",
  HOME_CREATE_REQUEST: "/home/create-request",
  // ORDER
  ACCOUNT_ORDER: "/order",
  AFFILIATE_ORDER: "/affiliate-order",
  DETAIL_SIM: "/detail-sim/:id",

  // setting price
  SETTING_SIM_PRICE: "/setting-sim-price",
  SETTING_PACKAGE_PRICE: "/setting-package-price",

  // DEPOSITE AND WITHDRAWAL
  ACCOUNT_DEPOSITE_WITHDRAWAL: "/deposite-withdrawal",
  // ADMIN
  USER_MANAGEMENT: "/user-management",
  AgencyManager: "/agency-manager-b2b",
  AgencyManagerB2C: "/agency-manager-b2c",
  NETWORK_MANAGER: "/network-manager",
  AFFILIATE_MANAGER: "/affiliate-manager",

  // CREATE_ACCOUNT: '/create-account',
  SETTING_PERMISSIONS: "/decentralization-administrative",
  USER_DETAIL: "/user-detail",
  USER_PERMISSION: "/user-permission",
  NetworkPackage: "/network-package",
  CUSTOMER_MANAGERMENT: "/customer-management",
  SUPPLIER_MANAGERMENT: "/supplier-management",

  DASHBOARD_PURCHASING_REPORT: "/dashboard/purchasing-report",
  DASHBOARD_SALES_REPORT: "/dashboard/sales-report",
  DASHBOARD_DATA_REPORT: "/dashboard/data-report",
  DASHBOARD_SUMMARY_REPORT: "/dashboard/summary-report",

  WAREHOUSE_IMPORT_SEARCH: "/warehouse/import/search",
  WAREHOUSE_IMPORT_ADD: "/warehouse/import/add",
  WAREHOUSE_IMPORT_EDIT: "/warehouse/import/edit",
  WAREHOUSE_EXPORT: "/warehouse/export",
  WAREHOUSE_EXPORT_SEARCH: "/warehouse/export/search",
  WAREHOUSE_EXPORT_ADD: "/warehouse/export/add",
  WAREHOUSE_EXPORT_EDIT: "/warehouse/export/edit",
  SUGGESTED_WAREHOUSE: "/suggested-warehouse",

  SUBSCRIPTION_SEARCH_SIM_INFOMATION: "/subscription/search-sim-infomation",
  SUBSCRIPTION_SEARCH_INFO_SUBCRIBER: "/subscription/search-info-subcriber",
  SUBSCRIPTION_SEARCH_SUBCRIBER_IMPACT_HISTORY:
    "/subscription/search-subcriber-impact-history",

  CONTRACT_MANAGERMENT_CUSTOMER: "/contract-managerment/customer",
  CONTRACT_MANAGERMENT_SUPPLIER: "/contract-managerment/supplier",

  PHONE_PACKAGE: "/phone-package",
  SUBSCRIPTION_FEE: "/subscription-fee",

  SIM_MANAGER: "/sim-management",
  PACKAGE_MANAGER: "/package-management",

  BILLING: "/billing",

  NETWORK: "/network-manager",
  QUESTIONS_AND_ANSWERS: "/questions-and-answers",

  // Vinaphone
  SOLD_SIM_CARDS: "/list-sim-card",

  // REPORT
  SALES_REPORT: "/report/sales",
  PURCHASE_REPORT: "/report/purchase",
  INVENTORY_REPORT: "/report/inventory",

  SALES_REPORT_B2B: "/report/sales_b2b",
  PURCHASE_REPORT_B2B: "/report/purchase_b2b",
  INVENTORY_REPORT_B2B: "/report/inventory_b2b",
  // Leader
  ACCOUNT_INFO: "/account/info",
  ACCOUNT_TERMS: "/account/terms",
  ACCOUNT_PAYMENT: "/account/payment",
  PACKAGE_MANAGEMENT_SEARCH: "/package-management/search",
  SIM_MANAGER_SEARCH: "/sim-management/search",
  DATA_MANAGER: "/data-managerment",
  AGENT_ACCOUNT_CREATE: "/agent-support/create-account",
  AGENT_PREPAID_SERVICE: "/agent-support/prepaid-service",
  AGENT_POSTPAID_SERVICE: "/agent-support/postpaid-service",
  AGENT_SIM_PACKAGE_SERVICE: "/agent-support/sim-package-service",

  CUSTOMER_MANAGERMENT_SEARCH: "/customer-managerment/search",
  CUSTOMER_MANAGERMENT_DOWNLOAD: "/customer-managerment/download",

  SUBSCRIPTION_MANAGERMENT_SEARCH: "/subcription-managerment/search",

  REVENUE_SIM_QUANTITY_SOLD: "/revenue/sim-quantity-sold",
  REVENUE_PACKAGE_SOLD: "/revenue/package-sold",
  REVENUE_TOTAL: "/revenue/total",
  GROETH: "/growth",
  REVENUE_CUSTOMER_TOTAL: "/revenue/customer-total",
  USER_MANUAL: "/user-manual",
  NEW_SIM_DATA_INFORMATION: "/new-sim-data-information",
  HISTORY_ORDER: "/history-order",

  // Staff
  DASHBOARDB2C: "/dashboard-b2c",
  USER_TERMS: "/user-terms",
  SALES_BUY_SIM: "/sales/buy-sim",
  SALES_BUY_PACKAGE: "/sales/buy-package",

  DASHBOARD_PURCHASE: "/dashboard/purchase",
  DASHBOARD_CLICK: "/dashboard/click",
  DASHBOARD_REVENUE: "/dashboard/revenue",
  DASHBOARD_REFERRAL: "/dashboard/referral",

  BILLING_CALCULATE: "/billing/calculate",
  BILLING_INVOICE: "/billing/invoice",
  SALES: "/sales",
  SALES_SEARCH: "/sales/search",
  SALES_ADD: "/sales/add",
  SALES_EDIT: "/sales/edit",
  PAYMENT: "/payment",
  PAYMENT_SEARCH: "/payment/search",
  PAYMENT_ADD: "/payment/add",
  PAYMENT_EDIT: "/payment/edit",
  // REPORT: "/report",
  GENERAL_REPORT_B2B: "/report/general-report-b2b",
  GENERAL_REPORT_ADMIN: "/report/general-report",
  LIST_PACKAGE_REQUEST: "/list-package-request",
  LIST_ORDER_AGENCY_CHILD: "/list-order-agency-child",
  PACKAGE_PRICING: "/package-pricing",
  SETTING_DISCOUNT: "/setting-discount",
  BUY_PACKAGE_ANONYMOUS: "/buy-package-anonymous",
  PACKAGE_PURCHASE: "/package-purchase",
  COUNTRY_MANAGER: "/country-manager",
  PACKAGE_SALE_TYPE: "/package-sale-type",
  SALE_SETTING_REPORT: "/sale-setting-report",
  RETAIL_REPORT_B2B: "/retail-report-b2b",

  //POOL DATA
  CUSTOMER_POOL_DATA: "/customer-pool-data",
  ORDER_POOL_DATA: "/order-pool-data",
  REPORT_POOL_DATA: "/report-pool-data",
  REPORT_POOL_SIM: "/report-pool-sim",
  POOL_DATA_USER_MANAGEMENT: "/pool_data_customer",
  REPORT_POOL_WALLET: "/pool_wallet",
  REPORT_POOL_DATA_PURCHASE: "/pool_data_purchase",
  REPORT_POOL_DATA_SALE: "/pool_data_sale",
  SETTING_PRICE_POOL_DATA: "/setting-price-pool-data",
  RECEIPT_POOL_DATA: "/receipt-pool-data",
  DATA_RECEIPT_POOL_DATA: "/data-receipt-pool-data",
  ORDER_DATA_M2M: "/order-data-m2m",
  REPORT_INVENTORY_POOL_DATA: "/report-inventory-pool-data",
  REPORT_PACKAGE_INVENTORY_M2M: "/report-package-inventory-m2m",
  REPORT_RECEIPT_M2M: "/report-receipt-m2m",
  REPORT_ORDER_M2M: "/report-order-m2m",
  REPORT_POOL_DATA_WALLET_SELL: "/pool_data_wallet_sell",
  REPORT_POOL_DATA_WALLET_BUY: "/pool_data_wallet_buy",
  REPORT_POOL_DATA_WALLET_INVENTORY: "/pool_data_wallet_inventory",
  GENERAL_REPORT_POOL_DATA: "/general-report-pool-data",
  REPORT_RECONCILIATION_POOL_DATA: "/report-reconciliation-pool-data",
  SUBSCRIPTION_PACKAGE_CONFIG: "/subscription-package-config",
}

export default ROUTER

